const Header = () => {
    return (
        <header className="header">
            <span className="header_text">Google Books Search App</span>
        </header>
    )
}

export default Header;
